export function sellersPropertyDisclosureSupplementAdditionalStructure2026() {
return [   // Release 2025-12-31 12:28:11
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Radiobutton PropertyType Sellers Property Disclosure Residential", 
   isText: false,
   type: "checkbox",
   top: 264.36,
   left: 191.52,
   width: 8.76,
   height: 8.88
}
,
{
   page: 0,
   name: "Radiobutton PropertyType Sellers Property Disclosure Land", 
   isText: false,
   type: "checkbox",
   top: 289.56,
   left: 191.52,
   width: 8.76,
   height: 8.76
}
,
{
   page: 0,
   name: "Radiobutton PropertyType Sellers Property Disclosure Commercial", 
   isText: false,
   type: "checkbox",
   top: 314.64,
   left: 191.52,
   width: 8.76,
   height: 8.76
}
,
{
   page: 0,
   name: "Date SPD completed by Seller", 
   fontSize: 9,
   type: "date",
   top: 623.13,
   left: 248.074,
   width: 65.563,
   height: 12.836
}
,
{
   page: 0,
   name: "TextDate SPD Supplement completed by Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 623.48,
   left: 315.175,
   width: 233.945,
   height: 10.494
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 640.48,
   left: 111.72,
   width: 437.40,
   height: 12.458
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 658.48,
   left: 111.12,
   width: 438.00,
   height: 12.458
}
,
{
   page: 0,
   name: "Residential Dwelling", 
   isText: false,
   type: "checkbox",
   top: 681,
   left: 185.4,
   width: 8.88,
   height: 8.88
}
,
{
   page: 0,
   name: "Barn", 
   isText: false,
   type: "checkbox",
   top: 681,
   left: 287.28,
   width: 8.76,
   height: 8.88
}
,
{
   page: 0,
   name: "Detached Garage", 
   isText: false,
   type: "checkbox",
   top: 681,
   left: 324.24,
   width: 8.88,
   height: 8.88
}
,
{
   page: 0,
   name: "Other", 
   isText: false,
   type: "checkbox",
   top: 681,
   left: 410.4,
   width: 8.88,
   height: 8.88
}
,
{
   page: 0,
   name: "undefined", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 676.48,
   left: 452.4,
   width: 96.72,
   height: 12.458
}
,
{
   page: 0,
   name: "Additional Structure DescriptionName", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 694.48,
   left: 234.96,
   width: 314.16,
   height: 12.4581
}
,
{
   page: 0,
   name: "Year Built", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 712.48,
   left: 119.16,
   width: 429.96,
   height: 12.4581
}
,
{
   page: 1,
   name: "is", 
   isText: false,
   type: "checkbox",
   top: 85.28,
   left: 97.92,
   width: 9.96,
   height: 8.029
}
,
{
   page: 1,
   name: "is not currently occupying the Additional Structure", 
   isText: false,
   type: "checkbox",
   top: 85.28,
   left: 117.12,
   width: 9.96,
   height: 8.029
}
,
{
   page: 1,
   name: "vacant", 
   isText: false,
   type: "checkbox",
   top: 133.8,
   left: 486.36,
   width: 10.08,
   height: 6.72
}
,
{
   page: 1,
   name: "undefined_2", 
   isText: false,
   type: "checkbox",
   top: 133.8,
   left: 525,
   width: 10.08,
   height: 6.72
}
,
{
   page: 1,
   name: "occupied", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 104.869,
   left: 488.28,
   width: 80.04,
   height: 13.091
}
,
{
   page: 1,
   name: "YesStructural problems with improvements", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 285.12,
   left: 286.68,
   width: 25.92,
   height: 16.56
}
,
{
   page: 1,
   name: "CommentsStructural problems with improvements", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 284.12,
   left: 314.4,
   width: 260.88,
   height: 16.56
}
,
{
   page: 1,
   name: "YesStructural supports or reinforcements added", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 304.32,
   left: 286.68,
   width: 25.92,
   height: 17.28
}
,
{
   page: 1,
   name: "CommentsStructural supports or reinforcements added", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 303.32,
   left: 314.4,
   width: 260.88,
   height: 17.28
}
,
{
   page: 1,
   name: "YesMoisture andor water including but not limited to leakageseepage in the basementcrawlspace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 324.48,
   left: 286.92,
   width: 25.44,
   height: 24.48
}
,
{
   page: 1,
   name: "CommentsMoisture andor water including but not limited to leakageseepage in the basementcrawlspace", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 323.48,
   left: 314.64,
   width: 260.40,
   height: 24.48
}
,
{
   page: 1,
   name: "YesDamage due to termites other insects birds animals or rodents", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 350.28,
   left: 286.92,
   width: 25.44,
   height: 24.12
}
,
{
   page: 1,
   name: "CommentsDamage due to termites other insects birds animals or rodents", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 350.28,
   left: 314.64,
   width: 260.40,
   height: 24.12
}
,
{
   page: 1,
   name: "YesDamage due to hail wind fire flood or other casualty", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 377.04,
   left: 286.68,
   width: 25.92,
   height: 17.28
}
,
{
   page: 1,
   name: "CommentsDamage due to hail wind fire flood or other casualty", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 377.04,
   left: 314.4,
   width: 260.88,
   height: 17.28
}
,
{
   page: 1,
   name: "YesAny settling movement cracking heaving or breakage of the following", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 395.76,
   left: 287.04,
   width: 25.20,
   height: 26.04
}
,
{
   page: 1,
   name: "CommentsAny settling movement cracking heaving or breakage of the following", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 395.76,
   left: 314.76,
   width: 260.16,
   height: 26.04
}
,
{
   page: 1,
   name: "Yesa Foundations", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 424.44,
   left: 286.68,
   width: 25.92,
   height: 17.28
}
,
{
   page: 1,
   name: "Commentsa Foundations", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 424.44,
   left: 314.4,
   width: 260.88,
   height: 17.28
}
,
{
   page: 1,
   name: "Yesb Floors", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 444.36,
   left: 286.68,
   width: 25.92,
   height: 17.28
}
,
{
   page: 1,
   name: "Commentsb Floors", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 444.36,
   left: 314.4,
   width: 260.88,
   height: 17.28
}
,
{
   page: 1,
   name: "Yesc Interior walls", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 462.84,
   left: 286.8,
   width: 25.68,
   height: 18.72
}
,
{
   page: 1,
   name: "Commentsc Interior walls", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 462.84,
   left: 314.52,
   width: 260.64,
   height: 18.72
}
,
{
   page: 1,
   name: "Yesd Exterior walls", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 482.76,
   left: 286.8,
   width: 25.68,
   height: 18.84
}
,
{
   page: 1,
   name: "Commentsd Exterior walls", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 482.76,
   left: 314.52,
   width: 260.64,
   height: 18.84
}
,
{
   page: 1,
   name: "Yese Driveways", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 504.24,
   left: 286.68,
   width: 25.92,
   height: 17.28
}
,
{
   page: 1,
   name: "Commentse Driveways", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 504.24,
   left: 314.4,
   width: 260.88,
   height: 17.28
}
,
{
   page: 1,
   name: "Yesf Sidewalks", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 524.16,
   left: 286.68,
   width: 25.92,
   height: 17.28
}
,
{
   page: 1,
   name: "Commentsf Sidewalks", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 524.16,
   left: 314.4,
   width: 260.88,
   height: 17.28
}
,
{
   page: 1,
   name: "Yesg Patios", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 542.64,
   left: 286.8,
   width: 25.68,
   height: 18.72
}
,
{
   page: 1,
   name: "Commentsg Patios", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 542.64,
   left: 314.52,
   width: 260.64,
   height: 18.72
}
,
{
   page: 1,
   name: "Yesh Retaining walls", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 562.56,
   left: 286.8,
   width: 25.68,
   height: 18.84
}
,
{
   page: 1,
   name: "Commentsh Retaining walls", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 562.56,
   left: 314.52,
   width: 260.64,
   height: 18.84
}
,
{
   page: 1,
   name: "Yesi Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 584.04,
   left: 286.68,
   width: 25.92,
   height: 17.28
}
,
{
   page: 1,
   name: "Commentsi Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 584.04,
   left: 314.4,
   width: 260.88,
   height: 17.28
}
,
{
   page: 1,
   name: "YesWindow leaks", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 603.96,
   left: 286.68,
   width: 25.92,
   height: 17.28
}
,
{
   page: 1,
   name: "CommentsWindow leaks", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 603.96,
   left: 314.4,
   width: 260.88,
   height: 17.28
}
,
{
   page: 1,
   name: "YesExterior Artificial Stucco EIFS", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 622.32,
   left: 286.68,
   width: 25.92,
   height: 17.52
}
,
{
   page: 1,
   name: "CommentsExterior Artificial Stucco EIFS", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 622.32,
   left: 314.4,
   width: 260.88,
   height: 17.52
}
,
{
   page: 1,
   name: "Yes9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 642.48,
   left: 286.68,
   width: 25.92,
   height: 15.84
}
,
{
   page: 1,
   name: "Comments9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 642.48,
   left: 314.4,
   width: 260.88,
   height: 15.84
}
,
{
   page: 1,
   name: "Exterior Artificial Stucco EIFS10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 659.4,
   left: 68.4,
   width: 216.6,
   height: 17.52
}
,
{
   page: 1,
   name: "Yes10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 659.4,
   left: 286.68,
   width: 25.92,
   height: 17.52
}
,
{
   page: 1,
   name: "Comments10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 659.4,
   left: 314.4,
   width: 260.88,
   height: 17.52
}
,
{
   page: 2,
   name: "YesIndicate age of roof in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 86.16,
   left: 290.4,
   width: 24.96,
   height: 20.16
}
,
{
   page: 2,
   name: "CommentsIndicate age of roof in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 86.16,
   left: 317.4,
   width: 257.76,
   height: 20.16
}
,
{
   page: 2,
   name: "YesIndicate roof material in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 109.08,
   left: 290.4,
   width: 24.96,
   height: 20.16
}
,
{
   page: 2,
   name: "CommentsIndicate roof material in Comments", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 109.08,
   left: 317.4,
   width: 257.76,
   height: 20.16
}
,
{
   page: 2,
   name: "YesRoof is under warranty", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 130.44,
   left: 290.4,
   width: 24.96,
   height: 21.72
}
,
{
   page: 2,
   name: "CommentsRoof is under warranty", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 130.44,
   left: 317.4,
   width: 257.76,
   height: 21.72
}
,
{
   page: 2,
   name: "Yesa Date of warranty expiration b Warranty is transferable", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 153.36,
   left: 290.4,
   width: 24.96,
   height: 21.84
}
,
{
   page: 2,
   name: "Commentsa Date of warranty expiration b Warranty is transferable", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 153.36,
   left: 317.4,
   width: 257.76,
   height: 21.84
}
,
{
   page: 2,
   name: "Yesa Date of warranty expiration b Warranty is transferable_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 177.96,
   left: 290.4,
   width: 24.96,
   height: 20.16
}
,
{
   page: 2,
   name: "YesRoof work done while under current roof warranty", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 200.88,
   left: 290.4,
   width: 24.96,
   height: 20.16
}
,
{
   page: 2,
   name: "Yes No UnknownRoof work done while under current roof warranty", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 200.88,
   left: 317.4,
   width: 257.76,
   height: 20.16
}
,
{
   page: 2,
   name: "Yesa Date work completed", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 222.24,
   left: 290.4,
   width: 24.96,
   height: 21.72
}
,
{
   page: 2,
   name: "Yes No Unknowna Date work completed", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 222.24,
   left: 317.4,
   width: 257.76,
   height: 21.72
}
,
{
   page: 2,
   name: "YesRoof leak", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 282.96,
   left: 290.16,
   width: 25.44,
   height: 13.44
}
,
{
   page: 2,
   name: "CommentsRoof leak", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 282.96,
   left: 317.16,
   width: 258.24,
   height: 13.44
}
,
{
   page: 2,
   name: "YesDamage to roof", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 299.16,
   left: 290.4,
   width: 24.96,
   height: 19.32
}
,
{
   page: 2,
   name: "CommentsDamage to roof", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 299.16,
   left: 317.4,
   width: 257.76,
   height: 19.32
}
,
{
   page: 2,
   name: "YesDamage to skylight", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 319.56,
   left: 290.28,
   width: 25.20,
   height: 17.76
}
,
{
   page: 2,
   name: "CommentsDamage to skylight", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 319.56,
   left: 317.28,
   width: 258.00,
   height: 17.76
}
,
{
   page: 2,
   name: "YesDamage to gutter or downspout", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 339.84,
   left: 290.16,
   width: 25.44,
   height: 14.52
}
,
{
   page: 2,
   name: "CommentsDamage to gutter or downspout", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 339.84,
   left: 317.16,
   width: 258.24,
   height: 14.52
}
,
{
   page: 2,
   name: "YesOther roof problems issues or concerns", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 355.44,
   left: 290.28,
   width: 25.20,
   height: 15.72
}
,
{
   page: 2,
   name: "CommentsOther roof problems issues or concerns", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 355.44,
   left: 317.28,
   width: 258.00,
   height: 15.72
}
,
{
   page: 2,
   name: "Other roof problems issues or concerns10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 372.24,
   left: 68.28,
   width: 220.32,
   height: 15.72
}
,
{
   page: 2,
   name: "Yes10_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 372.24,
   left: 290.28,
   width: 25.20,
   height: 15.72
}
,
{
   page: 2,
   name: "Comments10_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 372.24,
   left: 317.28,
   width: 258.00,
   height: 15.72
}
,
{
   page: 2,
   name: "YesBuiltin vacuum system  accessories", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 437.76,
   left: 279.36,
   width: 26.04,
   height: 14.40
}
,
{
   page: 2,
   name: "Age if knownBuiltin vacuum system  accessories", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 437.76,
   left: 306.84,
   width: 38.64,
   height: 14.40
}
,
{
   page: 2,
   name: "CommentsBuiltin vacuum system  accessories", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 437.76,
   left: 347.04,
   width: 228.36,
   height: 14.40
}
,
{
   page: 2,
   name: "YesClothes dryer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 453.12,
   left: 279.36,
   width: 26.04,
   height: 14.52
}
,
{
   page: 2,
   name: "Age if knownClothes dryer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 453.12,
   left: 306.84,
   width: 38.64,
   height: 14.52
}
,
{
   page: 2,
   name: "Gas", 
   isText: false,
   type: "checkbox",
   top: 456.8,
   left: 351.84,
   width: 8.88,
   height: 8.88
}
,
{
   page: 2,
   name: "Electric", 
   isText: false,
   type: "checkbox",
   top: 456.8,
   left: 379.44,
   width: 8.88,
   height: 8.88
}
,
{
   page: 2,
   name: "YesClothes washer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 470.16,
   left: 279.36,
   width: 26.04,
   height: 12.84
}
,
{
   page: 2,
   name: "Age if knownClothes washer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 470.16,
   left: 306.84,
   width: 38.64,
   height: 12.84
}
,
{
   page: 2,
   name: "Gas ElectricClothes washer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 470.16,
   left: 347.04,
   width: 228.36,
   height: 12.84
}
,
{
   page: 2,
   name: "YesDishwasher", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 483.96,
   left: 279.36,
   width: 26.04,
   height: 14.40
}
,
{
   page: 2,
   name: "Age if knownDishwasher", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 483.96,
   left: 306.84,
   width: 38.64,
   height: 14.40
}
,
{
   page: 2,
   name: "Gas ElectricDishwasher", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 483.96,
   left: 347.04,
   width: 228.36,
   height: 14.40
}
,
{
   page: 2,
   name: "YesDisposal", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 499.32,
   left: 279.36,
   width: 26.04,
   height: 14.52
}
,
{
   page: 2,
   name: "Age if knownDisposal", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 499.32,
   left: 306.84,
   width: 38.64,
   height: 14.52
}
,
{
   page: 2,
   name: "Gas ElectricDisposal", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 499.32,
   left: 347.04,
   width: 228.36,
   height: 14.52
}
,
{
   page: 2,
   name: "YesFreezer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 516.36,
   left: 279.36,
   width: 26.04,
   height: 12.84
}
,
{
   page: 2,
   name: "Age if knownFreezer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 516.36,
   left: 306.84,
   width: 38.64,
   height: 12.84
}
,
{
   page: 2,
   name: "Gas ElectricFreezer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 516.36,
   left: 347.04,
   width: 228.36,
   height: 12.84
}
,
{
   page: 2,
   name: "YesGas grill", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 530.16,
   left: 279.36,
   width: 26.04,
   height: 14.40
}
,
{
   page: 2,
   name: "Age if knownGas grill", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 530.16,
   left: 306.84,
   width: 38.64,
   height: 14.40
}
,
{
   page: 2,
   name: "Gas ElectricGas grill", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 530.16,
   left: 347.04,
   width: 228.36,
   height: 14.40
}
,
{
   page: 2,
   name: "YesRange ventilation system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 545.52,
   left: 279.36,
   width: 26.04,
   height: 14.52
}
,
{
   page: 2,
   name: "Age if knownRange ventilation system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 545.52,
   left: 306.84,
   width: 38.64,
   height: 14.52
}
,
{
   page: 2,
   name: "Gas ElectricRange ventilation system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 545.52,
   left: 347.04,
   width: 228.36,
   height: 14.52
}
,
{
   page: 2,
   name: "YesMicrowave oven", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 562.56,
   left: 279.36,
   width: 26.04,
   height: 12.84
}
,
{
   page: 2,
   name: "Age if knownMicrowave oven", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 562.56,
   left: 306.84,
   width: 38.64,
   height: 12.84
}
,
{
   page: 2,
   name: "Free standing Built in", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 562.56,
   left: 454.8,
   width: 120.6,
   height: 12.84
}
,
{
   page: 2,
   name: "undefined_4", 
   isText: false,
   type: "checkbox",
   top: 564.12,
   left: 352.56,
   width: 8.88,
   height: 8.88
}
,
{
   page: 2,
   name: "undefined_5", 
   isText: false,
   type: "checkbox",
   top: 564.12,
   left: 416.16,
   width: 8.76,
   height: 8.88
}
,
{
   page: 2,
   name: "YesOven", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 576.36,
   left: 279.36,
   width: 26.04,
   height: 14.40
}
,
{
   page: 2,
   name: "Age if knownOven", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 576.36,
   left: 306.84,
   width: 38.64,
   height: 14.40
}
,
{
   page: 2,
   name: "Gas_2", 
   isText: false,
   type: "checkbox",
   top: 579.48,
   left: 352.56,
   width: 8.88,
   height: 8.88
}
,
{
   page: 2,
   name: "Electric_2", 
   isText: false,
   type: "checkbox",
   top: 579.48,
   left: 381.36,
   width: 8.88,
   height: 8.88
}
,
{
   page: 2,
   name: "Single", 
   isText: false,
   type: "checkbox",
   top: 579.48,
   left: 424.2,
   width: 8.88,
   height: 8.88
}
,
{
   page: 2,
   name: "Double", 
   isText: false,
   type: "checkbox",
   top: 579.48,
   left: 462,
   width: 8.88,
   height: 8.88
}
,
{
   page: 2,
   name: "YesRangeStove", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 591.72,
   left: 279.36,
   width: 26.04,
   height: 14.52
}
,
{
   page: 2,
   name: "Age if knownRangeStove", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 591.72,
   left: 306.84,
   width: 38.64,
   height: 14.52
}
,
{
   page: 2,
   name: "Gas_3", 
   isText: false,
   type: "checkbox",
   top: 594.96,
   left: 352.56,
   width: 8.88,
   height: 8.76
}
,
{
   page: 2,
   name: "Electric_3", 
   isText: false,
   type: "checkbox",
   top: 594.96,
   left: 381.36,
   width: 8.88,
   height: 8.76
}
,
{
   page: 2,
   name: "Free Standing", 
   isText: false,
   type: "checkbox",
   top: 594.96,
   left: 424.2,
   width: 8.88,
   height: 8.76
}
,
{
   page: 2,
   name: "DropIn", 
   isText: false,
   type: "checkbox",
   top: 594.96,
   left: 489.24,
   width: 8.76,
   height: 8.76
}
,
{
   page: 2,
   name: "YesRefrigerator", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 608.76,
   left: 279.36,
   width: 26.04,
   height: 12.84
}
,
{
   page: 2,
   name: "Age if knownRefrigerator", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 608.76,
   left: 306.84,
   width: 38.64,
   height: 12.84
}
,
{
   page: 2,
   name: "Gas Electric Free Standing DropInRefrigerator", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 608.76,
   left: 347.04,
   width: 228.36,
   height: 12.84
}
,
{
   page: 2,
   name: "YesTV antenna", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 622.92,
   left: 279.72,
   width: 25.32,
   height: 38.04
}
,
{
   page: 2,
   name: "Age if knownTV antenna", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 623.28,
   left: 307.56,
   width: 37.20,
   height: 37.68
}
,
{
   page: 2,
   name: "Owned Leased If leased provide the name and contact information of entity leased from", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 645.12,
   left: 347.16,
   width: 228.12,
   height: 15.84
}
,
{
   page: 2,
   name: "undefined_6", 
   isText: false,
   type: "checkbox",
   top: 625.68,
   left: 352.56,
   width: 8.88,
   height: 8.88
}
,
{
   page: 2,
   name: "undefined_7", 
   isText: false,
   type: "checkbox",
   top: 625.68,
   left: 395.64,
   width: 8.88,
   height: 8.88
}
,
{
   page: 2,
   name: "YesSatellite system or DSS dish", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 662.28,
   left: 279.72,
   width: 25.32,
   height: 38.16
}
,
{
   page: 2,
   name: "Age if knownSatellite system or DSS dish", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 662.64,
   left: 307.56,
   width: 37.20,
   height: 37.80
}
,
{
   page: 2,
   name: "Owned", 
   isText: false,
   type: "checkbox",
   top: 665.16,
   left: 352.56,
   width: 8.88,
   height: 8.76
}
,
{
   page: 2,
   name: "Leased If leased provide the name and", 
   isText: false,
   type: "checkbox",
   top: 665.16,
   left: 395.64,
   width: 8.88,
   height: 8.76
}
,
{
   page: 2,
   name: "YesTrash compactor", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 702.96,
   left: 279.36,
   width: 26.04,
   height: 12.84
}
,
{
   page: 2,
   name: "Age if knownTrash compactor", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 702.96,
   left: 306.84,
   width: 38.64,
   height: 12.84
}
,
{
   page: 2,
   name: "Owned Leased If leased provide the name and contact information of entity leased fromTrash compactor", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 702.96,
   left: 347.04,
   width: 228.36,
   height: 12.84
}
,
{
   page: 2,
   name: "Trash compactor16", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 716.76,
   left: 72.84,
   width: 205.08,
   height: 14.52
}
,
{
   page: 2,
   name: "Yes16", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 716.76,
   left: 279.36,
   width: 26.04,
   height: 14.52
}
,
{
   page: 2,
   name: "Age if known16", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 716.76,
   left: 306.84,
   width: 38.64,
   height: 14.52
}
,
{
   page: 2,
   name: "Owned Leased If leased provide the name and contact information of entity leased from16", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 716.76,
   left: 347.04,
   width: 228.36,
   height: 14.52
}
,
{
   page: 2,
   name: "Check Box8", 
   isText: false,
   type: "checkbox",
   top: 186.141,
   left: 322.14,
   width: 10.08,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box9", 
   isText: false,
   type: "checkbox",
   top: 184.767,
   left: 350.989,
   width: 10.080,
   height: 10.080
}
,
{
   page: 2,
   name: "Check Box14", 
   isText: false,
   type: "checkbox",
   top: 185.454,
   left: 378.15,
   width: 10.08,
   height: 10.080
}
,
{
   page: 3,
   name: "Yes220 Volt service", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 96.96,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if known220 Volt service", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 96.96,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: "Comments220 Volt service", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 96.96,
   left: 347.4,
   width: 228.12,
   height: 12.84
}
,
{
   page: 3,
   name: "Electrical Service Amps", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 111.96,
   left: 165.48,
   width: 103.44,
   height: 9.48
}
,
{
   page: 3,
   name: "YesElectrical Service Amps", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 112.32,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownElectrical Service Amps", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 112.32,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: "CommentsElectrical Service Amps", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 112.32,
   left: 347.4,
   width: 228.12,
   height: 12.84
}
,
{
   page: 3,
   name: "YesLandscape lighting", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 127.8,
   left: 279.84,
   width: 25.56,
   height: 12.72
}
,
{
   page: 3,
   name: "Age if knownLandscape lighting", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 127.8,
   left: 306.84,
   width: 39.00,
   height: 12.72
}
,
{
   page: 3,
   name: "CommentsLandscape lighting", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 127.8,
   left: 347.4,
   width: 228.12,
   height: 12.72
}
,
{
   page: 3,
   name: "YesElectric provider  provide name in Comments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 143.16,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownElectric provider  provide name in Comments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 143.16,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: "CommentsElectric provider  provide name in Comments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 143.16,
   left: 347.4,
   width: 228.12,
   height: 12.84
}
,
{
   page: 3,
   name: "YesCableTV provider  provide name in Comments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 158.52,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownCableTV provider  provide name in Comments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 158.52,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: "CommentsCableTV provider  provide name in Comments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 158.52,
   left: 347.4,
   width: 228.12,
   height: 12.84
}
,
{
   page: 3,
   name: "YesInternet provider  provide name in Comments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 174,
   left: 279.84,
   width: 25.56,
   height: 12.72
}
,
{
   page: 3,
   name: "Age if knownInternet provider  provide name in Comments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 174,
   left: 306.84,
   width: 39.00,
   height: 12.72
}
,
{
   page: 3,
   name: "CommentsInternet provider  provide name in Comments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 174,
   left: 347.4,
   width: 228.12,
   height: 12.72
}
,
{
   page: 3,
   name: "YesSolar panels", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 189.72,
   left: 280.2,
   width: 24.84,
   height: 72.48
}
,
{
   page: 3,
   name: "Age if knownSolar panels", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 190.08,
   left: 307.56,
   width: 37.56,
   height: 72.12
}
,
{
   page: 3,
   name: "Owned Leased If leased provide the name and contact information of entity leased from Output", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 236.64,
   left: 347.76,
   width: 227.40,
   height: 25.56
}
,
{
   page: 3,
   name: "undefined_8", 
   isText: false,
   type: "checkbox",
   top: 190.92,
   left: 352.92,
   width: 8.88,
   height: 8.76
}
,
{
   page: 3,
   name: "undefined_9", 
   isText: false,
   type: "checkbox",
   top: 190.92,
   left: 396,
   width: 8.88,
   height: 8.76
}
,
{
   page: 3,
   name: "undefined_10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 225.84,
   left: 382.08,
   width: 185.333,
   height: 9.48
}
,
{
   page: 3,
   name: "YesWind generators", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 265.08,
   left: 280.2,
   width: 24.84,
   height: 36.48
}
,
{
   page: 3,
   name: "Age if knownWind generators", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 265.44,
   left: 307.56,
   width: 37.56,
   height: 36.12
}
,
{
   page: 3,
   name: "Owned Leased If leased provide the name and contact information of entity leased from_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 285.72,
   left: 347.52,
   width: 227.88,
   height: 15.84
}
,
{
   page: 3,
   name: "undefined_11", 
   isText: false,
   type: "checkbox",
   top: 266.28,
   left: 352.92,
   width: 8.88,
   height: 8.76
}
,
{
   page: 3,
   name: "undefined_12", 
   isText: false,
   type: "checkbox",
   top: 266.28,
   left: 396,
   width: 8.88,
   height: 8.76
}
,
{
   page: 3,
   name: "YesSecurity system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 304.56,
   left: 280.2,
   width: 24.84,
   height: 36.36
}
,
{
   page: 3,
   name: "Age if knownSecurity system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 304.92,
   left: 307.56,
   width: 37.56,
   height: 36.00
}
,
{
   page: 3,
   name: "Owned Leased If leased provide the name and contact information of entity leased from_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 325.08,
   left: 347.52,
   width: 227.88,
   height: 15.84
}
,
{
   page: 3,
   name: "undefined_13", 
   isText: false,
   type: "checkbox",
   top: 305.64,
   left: 352.92,
   width: 8.88,
   height: 8.88
}
,
{
   page: 3,
   name: "undefined_14", 
   isText: false,
   type: "checkbox",
   top: 305.64,
   left: 396,
   width: 8.88,
   height: 8.88
}
,
{
   page: 3,
   name: "YesDoorbell", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 343.56,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownDoorbell", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 343.56,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: "undefined_15", 
   isText: false,
   type: "checkbox",
   top: 345.12,
   left: 352.92,
   width: 8.88,
   height: 8.76
}
,
{
   page: 3,
   name: "undefined_16", 
   isText: false,
   type: "checkbox",
   top: 345.12,
   left: 390.24,
   width: 8.88,
   height: 8.76
}
,
{
   page: 3,
   name: "undefined_17", 
   isText: false,
   type: "checkbox",
   top: 345.12,
   left: 436.56,
   width: 8.76,
   height: 8.76
}
,
{
   page: 3,
   name: "YesSmokefire detectors", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 358.92,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownSmokefire detectors", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 358.92,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: "undefined_18", 
   isText: false,
   type: "checkbox",
   top: 360.48,
   left: 352.92,
   width: 8.88,
   height: 8.76
}
,
{
   page: 3,
   name: "undefined_19", 
   isText: false,
   type: "checkbox",
   top: 360.48,
   left: 394.2,
   width: 8.88,
   height: 8.76
}
,
{
   page: 3,
   name: "YesCarbon monoxide alarms", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 374.4,
   left: 279.84,
   width: 25.56,
   height: 12.72
}
,
{
   page: 3,
   name: "Age if knownCarbon monoxide alarms", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 374.4,
   left: 306.84,
   width: 39.00,
   height: 12.72
}
,
{
   page: 3,
   name: "undefined_20", 
   isText: false,
   type: "checkbox",
   top: 375.84,
   left: 352.92,
   width: 8.88,
   height: 8.88
}
,
{
   page: 3,
   name: "undefined_21", 
   isText: false,
   type: "checkbox",
   top: 375.84,
   left: 394.2,
   width: 8.88,
   height: 8.88
}
,
{
   page: 3,
   name: "YesInternet wiring", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 390.12,
   left: 280.2,
   width: 24.84,
   height: 24.48
}
,
{
   page: 3,
   name: "Age if knownInternet wiring", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 390.12,
   left: 307.2,
   width: 38.28,
   height: 24.48
}
,
{
   page: 3,
   name: "Other_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 402.24,
   left: 390.12,
   width: 185.213,
   height: 10.854
}
,
{
   page: 3,
   name: "undefined_22", 
   isText: false,
   type: "checkbox",
   top: 391.32,
   left: 388.8,
   width: 8.76,
   height: 8.76
}
,
{
   page: 3,
   name: "undefined_23", 
   isText: false,
   type: "checkbox",
   top: 391.32,
   left: 420.6,
   width: 8.76,
   height: 8.76
}
,
{
   page: 3,
   name: "undefined_24", 
   isText: false,
   type: "checkbox",
   top: 391.32,
   left: 464.88,
   width: 8.76,
   height: 8.76
}
,
{
   page: 3,
   name: "YesBuilt in sound system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 417.48,
   left: 280.2,
   width: 24.84,
   height: 24.48
}
,
{
   page: 3,
   name: "Age if knownBuilt in sound system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 417.48,
   left: 307.2,
   width: 38.28,
   height: 24.48
}
,
{
   page: 3,
   name: "SpeakersBuilt In", 
   isText: false,
   type: "checkbox",
   top: 418.68,
   left: 352.92,
   width: 8.88,
   height: 8.76
}
,
{
   page: 3,
   name: "SpeakersWireless", 
   isText: false,
   type: "checkbox",
   top: 430.68,
   left: 352.92,
   width: 8.88,
   height: 8.76
}
,
{
   page: 3,
   name: "WiringBuilt In", 
   isText: false,
   type: "checkbox",
   top: 418.68,
   left: 433.08,
   width: 8.88,
   height: 8.76
}
,
{
   page: 3,
   name: "Built in sound system15", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 444.6,
   left: 68.28,
   width: 210.12,
   height: 12.72
}
,
{
   page: 3,
   name: "Yes15", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 444.6,
   left: 279.84,
   width: 25.56,
   height: 12.72
}
,
{
   page: 3,
   name: "Age if known15", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 444.6,
   left: 306.84,
   width: 39.00,
   height: 12.72
}
,
{
   page: 3,
   name: "SpeakersBuilt In WiringBuilt In SpeakersWireless15", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 444.6,
   left: 347.4,
   width: 228.12,
   height: 12.72
}
,
{
   page: 3,
   name: "YesSecurity system_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 496.32,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownSecurity system_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 496.32,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: "CommentsSecurity system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 496.32,
   left: 347.4,
   width: 228.12,
   height: 12.84
}
,
{
   page: 3,
   name: "YesSmokefire detectors_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 511.8,
   left: 279.84,
   width: 25.56,
   height: 12.72
}
,
{
   page: 3,
   name: "Age if knownSmokefire detectors_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 511.8,
   left: 306.84,
   width: 39.00,
   height: 12.72
}
,
{
   page: 3,
   name: "CommentsSmokefire detectors", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 511.8,
   left: 347.4,
   width: 228.12,
   height: 12.72
}
,
{
   page: 3,
   name: "YesCarbon monoxide alarm", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 527.16,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownCarbon monoxide alarm", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 527.16,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: "CommentsCarbon monoxide alarm", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 527.16,
   left: 347.4,
   width: 228.12,
   height: 12.84
}
,
{
   page: 3,
   name: "YesLight fixtures", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 542.52,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownLight fixtures", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 542.52,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: "CommentsLight fixtures", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 542.52,
   left: 347.4,
   width: 228.12,
   height: 12.84
}
,
{
   page: 3,
   name: "YesSwitches  outlets", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 558,
   left: 279.84,
   width: 25.56,
   height: 12.72
}
,
{
   page: 3,
   name: "Age if knownSwitches  outlets", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 558,
   left: 306.84,
   width: 39.00,
   height: 12.72
}
,
{
   page: 3,
   name: "CommentsSwitches  outlets", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 558,
   left: 347.4,
   width: 228.12,
   height: 12.72
}
,
{
   page: 3,
   name: "YesCable TV wiring and jacks", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 573.36,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownCable TV wiring and jacks", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 573.36,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: "CommentsCable TV wiring and jacks", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 573.36,
   left: 347.4,
   width: 228.12,
   height: 12.84
}
,
{
   page: 3,
   name: "YesInternet wiring_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 588.72,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownInternet wiring_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 588.72,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: "CommentsInternet wiring", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 588.72,
   left: 347.4,
   width: 228.12,
   height: 12.84
}
,
{
   page: 3,
   name: "YesInside telephone wiring  blocksjacks", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 604.2,
   left: 279.84,
   width: 25.56,
   height: 12.72
}
,
{
   page: 3,
   name: "Age if knownInside telephone wiring  blocksjacks", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 604.2,
   left: 306.84,
   width: 39.00,
   height: 12.72
}
,
{
   page: 3,
   name: "CommentsInside telephone wiring  blocksjacks", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 604.2,
   left: 347.4,
   width: 228.12,
   height: 12.72
}
,
{
   page: 3,
   name: "YesCeiling fans", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 619.56,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownCeiling fans", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 619.56,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: "CommentsCeiling fans", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 619.56,
   left: 347.4,
   width: 228.12,
   height: 12.84
}
,
{
   page: 3,
   name: "YesBathroom vent fans", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 634.92,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownBathroom vent fans", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 634.92,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: "CommentsBathroom vent fans", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 634.92,
   left: 347.4,
   width: 228.12,
   height: 12.84
}
,
{
   page: 3,
   name: "YesGarage door opener and remote control", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 650.76,
   left: 280.2,
   width: 24.84,
   height: 24.36
}
,
{
   page: 3,
   name: "Age if knownGarage door opener and remote control", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 650.76,
   left: 307.2,
   width: 38.28,
   height: 24.36
}
,
{
   page: 3,
   name: "of remoteopeners", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 650.76,
   left: 429,
   width: 40.56,
   height: 9.48
}
,
{
   page: 3,
   name: "YesGarage door keyless entry", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 677.76,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownGarage door keyless entry", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 677.76,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: " of remoteopenersGarage door keyless entry", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 677.76,
   left: 347.4,
   width: 228.12,
   height: 12.84
}
,
{
   page: 3,
   name: "YesBuilt in intercom system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 693.12,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownBuilt in intercom system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 693.12,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: " of remoteopenersBuilt in intercom system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 693.12,
   left: 347.4,
   width: 228.12,
   height: 12.84
}
,
{
   page: 3,
   name: "YesDoorbell_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 708.6,
   left: 279.84,
   width: 25.56,
   height: 12.72
}
,
{
   page: 3,
   name: "Age if knownDoorbell_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 708.6,
   left: 306.84,
   width: 39.00,
   height: 12.72
}
,
{
   page: 3,
   name: " of remoteopenersDoorbell", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 708.6,
   left: 347.4,
   width: 228.12,
   height: 12.72
}
,
{
   page: 3,
   name: "YesBuilt in sound system_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 723.96,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 3,
   name: "Age if knownBuilt in sound system_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 723.96,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 3,
   name: " of remoteopenersBuilt in sound system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 723.96,
   left: 347.4,
   width: 228.12,
   height: 12.84
}
,
{
   page: 3,
   name: "Check Box2", 
   isText: false,
   type: "checkbox",
   top: 392.201,
   left: 353.736,
   width: 10.080,
   height: 10.080
}
,
{
   page: 3,
   name: "Check Box3", 
   isText: false,
   type: "checkbox",
   top: 403.878,
   left: 353.736,
   width: 10.080,
   height: 10.080
}
,
{
   page: 4,
   name: "31", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 49.56,
   left: 68.28,
   width: 210.12,
   height: 12.84
}
,
{
   page: 4,
   name: "31Row1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 101.28,
   left: 347.314,
   width: 228.405,
   height: 14.88
}
,
{
   page: 4,
   name: "Electrical Service", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 104.4,
   left: 279.84,
   width: 25.56,
   height: 12.72
}
,
{
   page: 4,
   name: "Aluminum wiring at the outlets 110", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 119.76,
   left: 279.84,
   width: 25.56,
   height: 12.72
}
,
{
   page: 4,
   name: "Solar panels", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 135.12,
   left: 279.84,
   width: 25.56,
   height: 12.72
}
,
{
   page: 4,
   name: "Wind generators", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 150.6,
   left: 279.84,
   width: 25.56,
   height: 12.72
}
,
{
   page: 4,
   name: "Electric wiring or panel", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 165.96,
   left: 279.84,
   width: 25.56,
   height: 12.72
}
,
{
   page: 4,
   name: "Electric wiring or panel37", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 181.32,
   left: 68.28,
   width: 210.12,
   height: 12.84
}
,
{
   page: 4,
   name: "E", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 118.909,
   left: 347.314,
   width: 228.405,
   height: 14.880
}
,
{
   page: 4,
   name: "YesOverhead doors including garage doors", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 245.64,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 4,
   name: "Age if knownOverhead doors including garage doors", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 245.64,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 4,
   name: "CommentsOverhead doors including garage doors", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 245.64,
   left: 347.4,
   width: 228.72,
   height: 12.84
}
,
{
   page: 4,
   name: "YesEntry gate system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 261,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 4,
   name: "Age if knownEntry gate system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 261.0,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 4,
   name: "CommentsEntry gate system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 261,
   left: 347.4,
   width: 228.72,
   height: 12.84
}
,
{
   page: 4,
   name: "YesElevator", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 274.8,
   left: 279.84,
   width: 25.56,
   height: 14.52
}
,
{
   page: 4,
   name: "Age if knownElevator", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 274.8,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 4,
   name: "CommentsElevator", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 274.8,
   left: 347.4,
   width: 228.72,
   height: 14.52
}
,
{
   page: 4,
   name: "Sump pumps  of", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 291.48,
   left: 147,
   width: 43.56,
   height: 10.32
}
,
{
   page: 4,
   name: "YesSump pumps  of", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 291.84,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 4,
   name: "Age if knownSump pumps  of", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 291.84,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 4,
   name: "CommentsSump pumps  of", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 291.84,
   left: 347.4,
   width: 228.72,
   height: 12.84
}
,
{
   page: 4,
   name: "YesRecycle pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 307.2,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 4,
   name: "Age if knownRecycle pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 307.2,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 4,
   name: "CommentsRecycle pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 307.2,
   left: 347.4,
   width: 228.72,
   height: 12.84
}
,
{
   page: 4,
   name: "YesLifts or Hoists", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 321,
   left: 279.84,
   width: 25.56,
   height: 14.52
}
,
{
   page: 4,
   name: "Age if knownLifts or Hoists", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 321,
   left: 306.84,
   width: 39.00,
   height: 14.52
}
,
{
   page: 4,
   name: "CommentsLifts or Hoists", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 321,
   left: 347.4,
   width: 228.72,
   height: 14.52
}
,
{
   page: 4,
   name: "Lifts or Hoists7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 338.04,
   left: 68.4,
   width: 210.0,
   height: 12.84
}
,
{
   page: 4,
   name: "Yes7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 338.04,
   left: 279.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 4,
   name: "Age if known7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 338.04,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 4,
   name: "Comments7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 338.04,
   left: 347.4,
   width: 228.72,
   height: 12.84
}
,
{
   page: 4,
   name: "F", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 133.69,
   left: 347.969,
   width: 227.335,
   height: 12.731
}
,
{
   page: 4,
   name: "YesFurnace", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 417.96,
   left: 284.52,
   width: 25.56,
   height: 12.84
}
,
{
   page: 4,
   name: "Age if knownFurnace", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 417.96,
   left: 311.52,
   width: 39.00,
   height: 12.84
}
,
{
   page: 4,
   name: "CommentsFurnace", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 417.96,
   left: 352.08,
   width: 222.96,
   height: 12.84
}
,
{
   page: 4,
   name: "1Row1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 150.01,
   left: 347.314,
   width: 228.645,
   height: 12.512
}
,
{
   page: 4,
   name: "Yesa Furnace Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 432.12,
   left: 284.88,
   width: 24.84,
   height: 38.04
}
,
{
   page: 4,
   name: "Age if knowna Furnace Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 432.48,
   left: 312.24,
   width: 37.56,
   height: 37.68
}
,
{
   page: 4,
   name: "Forced Air Gas", 
   isText: false,
   type: "checkbox",
   top: 434.88,
   left: 357.6,
   width: 8.88,
   height: 8.88
}
,
{
   page: 4,
   name: "Forced Air Propane", 
   isText: false,
   type: "checkbox",
   top: 446.88,
   left: 357.6,
   width: 8.88,
   height: 8.88
}
,
{
   page: 4,
   name: "Other specify", 
   isText: false,
   type: "checkbox",
   top: 458.88,
   left: 357.6,
   width: 8.88,
   height: 8.88
}
,
{
   page: 4,
   name: "Forced Air Electric", 
   isText: false,
   type: "checkbox",
   top: 434.88,
   left: 427.92,
   width: 8.88,
   height: 8.88
}
,
{
   page: 4,
   name: "Radiant", 
   isText: false,
   type: "checkbox",
   top: 446.88,
   left: 443.4,
   width: 8.88,
   height: 8.88
}
,
{
   page: 4,
   name: "Gravity Flow", 
   isText: false,
   type: "checkbox",
   top: 446.88,
   left: 486.24,
   width: 8.76,
   height: 8.88
}
,
{
   page: 4,
   name: "1Row2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 163.794,
   left: 347.606,
   width: 227.399,
   height: 14.520
}
,
{
   page: 4,
   name: "Yesb Number of Units", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 471.12,
   left: 284.52,
   width: 25.56,
   height: 14.52
}
,
{
   page: 4,
   name: "Age if knownb Number of Units", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 471.12,
   left: 311.52,
   width: 39.00,
   height: 14.52
}
,
{
   page: 4,
   name: "Forced Air Gas Forced Air Electric Forced Air Propane Radiant Gravity Flow Other specifyb Number of Units", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 471.12,
   left: 352.08,
   width: 222.96,
   height: 14.52
}
,
{
   page: 4,
   name: "1Row3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 180.18,
   left: 347.969,
   width: 227.203,
   height: 13.441
}
,
{
   page: 4,
   name: "Yesc Zoned", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 488.52,
   left: 284.88,
   width: 24.84,
   height: 36.48
}
,
{
   page: 4,
   name: "Age if knownc Zoned", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 488.88,
   left: 312.24,
   width: 37.56,
   height: 36.12
}
,
{
   page: 4,
   name: "YesHeating system other than furnace", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 525.96,
   left: 284.52,
   width: 25.56,
   height: 14.40
}
,
{
   page: 4,
   name: "Age if knownHeating system other than furnace", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 525.96,
   left: 311.52,
   width: 39.00,
   height: 14.40
}
,
{
   page: 4,
   name: "Location of zone 1 Location of zone 2 Location of zone 3Heating system other than furnace", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 525.96,
   left: 352.08,
   width: 222.96,
   height: 14.40
}
,
{
   page: 4,
   name: "2Row1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 486.862,
   left: 428.246,
   width: 145.712,
   height: 11.378
}
,
{
   page: 4,
   name: "Yesa TypeFuel", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 541.32,
   left: 284.52,
   width: 25.56,
   height: 14.52
}
,
{
   page: 4,
   name: "Age if knowna TypeFuel", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 541.32,
   left: 311.52,
   width: 39.00,
   height: 14.52
}
,
{
   page: 4,
   name: "Location of zone 1 Location of zone 2 Location of zone 3a TypeFuel", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 541.32,
   left: 352.08,
   width: 222.96,
   height: 14.52
}
,
{
   page: 4,
   name: "2Row2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 499.807,
   left: 428.246,
   width: 145.712,
   height: 12.841
}
,
{
   page: 4,
   name: "Yesb TypeFuel", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 558.36,
   left: 284.52,
   width: 25.56,
   height: 12.84
}
,
{
   page: 4,
   name: "Age if knownb TypeFuel", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 558.36,
   left: 311.52,
   width: 39.00,
   height: 12.84
}
,
{
   page: 4,
   name: "Location of zone 1 Location of zone 2 Location of zone 3b TypeFuel", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 558.36,
   left: 352.08,
   width: 222.96,
   height: 12.84
}
,
{
   page: 4,
   name: "YesFireplace", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 572.16,
   left: 284.52,
   width: 25.56,
   height: 14.40
}
,
{
   page: 4,
   name: "Age if knownFireplace", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 572.16,
   left: 311.52,
   width: 39.00,
   height: 14.40
}
,
{
   page: 4,
   name: "Location of zone 1 Location of zone 2 Location of zone 3Fireplace", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 572.16,
   left: 352.08,
   width: 222.96,
   height: 14.40
}
,
{
   page: 4,
   name: "Yesa Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 588,
   left: 285,
   width: 24.6,
   height: 26.04
}
,
{
   page: 4,
   name: "Age if knowna Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 588,
   left: 312,
   width: 38.04,
   height: 26.04
}
,
{
   page: 4,
   name: "Masonry", 
   isText: false,
   type: "checkbox",
   top: 590.76,
   left: 357.6,
   width: 8.88,
   height: 8.76
}
,
{
   page: 4,
   name: "Insert", 
   isText: false,
   type: "checkbox",
   top: 590.76,
   left: 404.4,
   width: 8.88,
   height: 8.76
}
,
{
   page: 4,
   name: "Wood Burning", 
   isText: false,
   type: "checkbox",
   top: 590.76,
   left: 439.68,
   width: 8.88,
   height: 8.76
}
,
{
   page: 4,
   name: "Direct Vent", 
   isText: false,
   type: "checkbox",
   top: 590.76,
   left: 508.32,
   width: 8.76,
   height: 8.76
}
,
{
   page: 4,
   name: "Other specify_2", 
   isText: false,
   type: "checkbox",
   top: 602.76,
   left: 357.6,
   width: 8.88,
   height: 8.76
}
,
{
   page: 4,
   name: "3Row2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 512.404,
   left: 428.246,
   width: 145.712,
   height: 12.840
}
,
{
   page: 4,
   name: "Yesb Fireplace starter", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 616.56,
   left: 284.52,
   width: 25.56,
   height: 12.84
}
,
{
   page: 4,
   name: "Age if knownb Fireplace starter", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 616.56,
   left: 311.52,
   width: 39.00,
   height: 12.84
}
,
{
   page: 4,
   name: "Switch", 
   isText: false,
   type: "checkbox",
   top: 618.12,
   left: 357.6,
   width: 8.88,
   height: 8.88
}
,
{
   page: 4,
   name: "Remote", 
   isText: false,
   type: "checkbox",
   top: 618.12,
   left: 397.32,
   width: 8.88,
   height: 8.88
}
,
{
   page: 4,
   name: "YesFree Standing Heating Stove", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 630.36,
   left: 284.52,
   width: 25.56,
   height: 14.40
}
,
{
   page: 4,
   name: "Age if knownFree Standing Heating Stove", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 630.36,
   left: 311.52,
   width: 39.00,
   height: 14.40
}
,
{
   page: 4,
   name: "Switch RemoteFree Standing Heating Stove", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 630.36,
   left: 352.08,
   width: 222.96,
   height: 14.40
}
,
{
   page: 4,
   name: "Yesa Fuel Source", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 646.08,
   left: 284.88,
   width: 24.84,
   height: 24.12
}
,
{
   page: 4,
   name: "Age if knowna Fuel Source", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 646.08,
   left: 311.88,
   width: 38.28,
   height: 24.12
}
,
{
   page: 4,
   name: "Wood Pellet Corn Gas Other specify", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 657.727,
   left: 427.538,
   width: 147.142,
   height: 10.964
}
,
{
   page: 4,
   name: "undefined_25", 
   isText: false,
   type: "checkbox",
   top: 648.12,
   left: 357.6,
   width: 8.88,
   height: 8.88
}
,
{
   page: 4,
   name: "undefined_26", 
   isText: false,
   type: "checkbox",
   top: 648.12,
   left: 394.44,
   width: 8.88,
   height: 8.88
}
,
{
   page: 4,
   name: "undefined_27", 
   isText: false,
   type: "checkbox",
   top: 648.12,
   left: 429.72,
   width: 8.88,
   height: 8.88
}
,
{
   page: 4,
   name: "undefined_28", 
   isText: false,
   type: "checkbox",
   top: 648.12,
   left: 462.6,
   width: 8.76,
   height: 8.88
}
,
{
   page: 4,
   name: "undefined_29", 
   isText: false,
   type: "checkbox",
   top: 659.16,
   left: 357.6,
   width: 8.88,
   height: 8.76
}
,
{
   page: 4,
   name: "YesDate fireplacewood stove chimneyflue last cleaned", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 671.16,
   left: 284.52,
   width: 25.56,
   height: 14.40
}
,
{
   page: 4,
   name: "Age if knownDate fireplacewood stove chimneyflue last cleaned", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 671.16,
   left: 311.52,
   width: 39.00,
   height: 14.40
}
,
{
   page: 4,
   name: "Do not know", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 600.946,
   left: 426.916,
   width: 147.600,
   height: 12.305
}
,
{
   page: 4,
   name: "undefined_30", 
   isText: false,
   type: "checkbox",
   top: 674.28,
   left: 357.6,
   width: 8.88,
   height: 8.88
}
,
{
   page: 4,
   name: "YesFuel tanks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 686.88,
   left: 284.88,
   width: 24.84,
   height: 38.16
}
,
{
   page: 4,
   name: "Age if knownFuel tanks", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 687.24,
   left: 312.24,
   width: 37.56,
   height: 37.80
}
,
{
   page: 4,
   name: "Owned Leased If leased provide the name and contact information of entity leased from_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 709.2,
   left: 352.2,
   width: 222.72,
   height: 15.84
}
,
{
   page: 4,
   name: "undefined_31", 
   isText: false,
   type: "checkbox",
   top: 689.76,
   left: 357.6,
   width: 8.88,
   height: 8.76
}
,
{
   page: 4,
   name: "undefined_32", 
   isText: false,
   type: "checkbox",
   top: 689.76,
   left: 402.96,
   width: 8.76,
   height: 8.76
}
,
{
   page: 4,
   name: "YesRadiant heating system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 727.56,
   left: 284.52,
   width: 25.56,
   height: 12.84
}
,
{
   page: 4,
   name: "Age if knownRadiant heating system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 727.56,
   left: 311.52,
   width: 39.00,
   height: 12.84
}
,
{
   page: 4,
   name: "undefined_33", 
   isText: false,
   type: "checkbox",
   top: 729.12,
   left: 357.6,
   width: 8.88,
   height: 8.88
}
,
{
   page: 4,
   name: "undefined_34", 
   isText: false,
   type: "checkbox",
   top: 729.12,
   left: 403.92,
   width: 8.88,
   height: 8.88
}
,
{
   page: 4,
   name: "Text33", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 102.491,
   left: 306.84,
   width: 39.00,
   height: 12.840
}
,
{
   page: 4,
   name: "Text34", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 119.247,
   left: 306.84,
   width: 39.00,
   height: 12.840
}
,
{
   page: 4,
   name: "Text35", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 133.909,
   left: 306.84,
   width: 39.00,
   height: 12.840
}
,
{
   page: 4,
   name: "Text36", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 150.141,
   left: 306.84,
   width: 39.00,
   height: 12.840
}
,
{
   page: 4,
   name: "Text37", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 164.232,
   left: 306.84,
   width: 39.00,
   height: 12.840
}
,
{
   page: 4,
   name: "Text38", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 179.894,
   left: 306.84,
   width: 39.00,
   height: 12.840
}
,
{
   page: 4,
   name: "Text4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 47.52,
   left: 347.314,
   width: 228.405,
   height: 14.88
}
,
{
   page: 4,
   name: "Text5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 49.68,
   left: 279.84,
   width: 25.56,
   height: 12.72
}
,
{
   page: 4,
   name: "Text6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 49.56,
   left: 306.84,
   width: 39.00,
   height: 12.84
}
,
{
   page: 4,
   name: "Text7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 180.272,
   left: 279.84,
   width: 25.56,
   height: 12.720
}
,
{
   page: 5,
   name: "a Interior Type", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 49.56,
   left: 284.52,
   width: 25.56,
   height: 12.84
}
,
{
   page: 5,
   name: "b Exterior Type", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 64.92,
   left: 284.52,
   width: 25.56,
   height: 12.84
}
,
{
   page: 5,
   name: "Air Conditioning", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 78.72,
   left: 284.52,
   width: 25.56,
   height: 14.40
}
,
{
   page: 5,
   name: "8Row1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 48.36,
   left: 351.272,
   width: 223.210,
   height: 12.84
}
,
{
   page: 5,
   name: "a Type", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 94.44,
   left: 284.88,
   width: 24.84,
   height: 38.16
}
,
{
   page: 5,
   name: "No of Units", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 96.24,
   left: 504.24,
   width: 18.00,
   height: 9.48
}
,
{
   page: 5,
   name: "Other specify_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 120.24,
   left: 471.84,
   width: 102.173,
   height: 10.854
}
,
{
   page: 5,
   name: "8Row2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 63.906,
   left: 351.272,
   width: 223.210,
   height: 12.840
}
,
{
   page: 5,
   name: "b Number of Units", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 135.12,
   left: 284.52,
   width: 25.56,
   height: 12.84
}
,
{
   page: 5,
   name: "Central Air Age No of Units Zoned Electric Other specifyb Number of Units", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 135.12,
   left: 352.08,
   width: 222.96,
   height: 12.84
}
,
{
   page: 5,
   name: "8Row3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 78.706,
   left: 351.272,
   width: 223.210,
   height: 12.840
}
,
{
   page: 5,
   name: "c Zoned", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 148.92,
   left: 284.52,
   width: 25.56,
   height: 14.40
}
,
{
   page: 5,
   name: "Central Air Age No of Units Zoned Electric Other specifyc Zoned", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 148.92,
   left: 352.08,
   width: 222.96,
   height: 14.40
}
,
{
   page: 5,
   name: "c Zoned9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 164.28,
   left: 68.52,
   width: 214.56,
   height: 14.52
}
,
{
   page: 5,
   name: "Central Air Age No of Units Zoned Electric Other specify9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 164.28,
   left: 352.08,
   width: 222.96,
   height: 14.52
}
,
{
   page: 5,
   name: "9Row1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 95.106,
   left: 311.52,
   width: 39.00,
   height: 29.585
}
,
{
   page: 5,
   name: "YesFurnace_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 216.12,
   left: 284.52,
   width: 25.56,
   height: 14.40
}
,
{
   page: 5,
   name: "Age if knownFurnace_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 216.12,
   left: 311.52,
   width: 39.00,
   height: 14.40
}
,
{
   page: 5,
   name: "CommentsFurnace_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 216.12,
   left: 352.08,
   width: 222.96,
   height: 14.40
}
,
{
   page: 5,
   name: "YesHeating System other than Furnace", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 231.48,
   left: 284.52,
   width: 25.56,
   height: 14.52
}
,
{
   page: 5,
   name: "Age if knownHeating System other than Furnace", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 231.48,
   left: 311.52,
   width: 39.00,
   height: 14.40
}
,
{
   page: 5,
   name: "CommentsHeating System other than Furnace", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 231.48,
   left: 352.08,
   width: 222.96,
   height: 14.52
}
,
{
   page: 5,
   name: "YesHeat Pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 248.52,
   left: 284.52,
   width: 25.56,
   height: 12.84
}
,
{
   page: 5,
   name: "Age if knownHeat Pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 248.52,
   left: 311.52,
   width: 39.00,
   height: 14.40
}
,
{
   page: 5,
   name: "CommentsHeat Pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 248.52,
   left: 352.08,
   width: 222.96,
   height: 12.84
}
,
{
   page: 5,
   name: "YesEvaporative cooler", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 262.32,
   left: 284.52,
   width: 25.56,
   height: 14.40
}
,
{
   page: 5,
   name: "Age if knownEvaporative cooler", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 262.32,
   left: 311.52,
   width: 39.00,
   height: 14.40
}
,
{
   page: 5,
   name: "CommentsEvaporative cooler", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 262.32,
   left: 352.08,
   width: 222.96,
   height: 14.40
}
,
{
   page: 5,
   name: "YesWindow air conditioning units", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 277.68,
   left: 284.52,
   width: 25.56,
   height: 14.52
}
,
{
   page: 5,
   name: "Age if knownWindow air conditioning units", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 277.68,
   left: 311.52,
   width: 39.00,
   height: 14.40
}
,
{
   page: 5,
   name: "CommentsWindow air conditioning units", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 277.68,
   left: 352.08,
   width: 222.96,
   height: 14.52
}
,
{
   page: 5,
   name: "YesCentral air conditioning", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 294.72,
   left: 284.52,
   width: 25.56,
   height: 12.84
}
,
{
   page: 5,
   name: "Age if knownCentral air conditioning", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 294.72,
   left: 311.52,
   width: 39.00,
   height: 14.40
}
,
{
   page: 5,
   name: "CommentsCentral air conditioning", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 294.72,
   left: 352.08,
   width: 222.96,
   height: 12.84
}
,
{
   page: 5,
   name: "YesAttic ventilation system attic only", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 308.52,
   left: 284.52,
   width: 25.56,
   height: 14.40
}
,
{
   page: 5,
   name: "Age if knownAttic ventilation system attic only", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 308.52,
   left: 311.52,
   width: 39.00,
   height: 14.40
}
,
{
   page: 5,
   name: "CommentsAttic ventilation system attic only", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 308.52,
   left: 352.08,
   width: 222.96,
   height: 14.40
}
,
{
   page: 5,
   name: "YesWhole house fan", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 323.88,
   left: 284.52,
   width: 25.56,
   height: 14.52
}
,
{
   page: 5,
   name: "Age if knownWhole house fan", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 323.88,
   left: 311.52,
   width: 39.00,
   height: 14.52
}
,
{
   page: 5,
   name: "CommentsWhole house fan", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 323.88,
   left: 352.08,
   width: 222.96,
   height: 14.52
}
,
{
   page: 5,
   name: "YesVent fans", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 340.92,
   left: 284.52,
   width: 25.56,
   height: 12.84
}
,
{
   page: 5,
   name: "Age if knownVent fans", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 340.92,
   left: 311.52,
   width: 39.00,
   height: 12.84
}
,
{
   page: 5,
   name: "CommentsVent fans", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 340.92,
   left: 352.08,
   width: 222.96,
   height: 12.84
}
,
{
   page: 5,
   name: "YesHumidifier", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 354.72,
   left: 284.52,
   width: 25.56,
   height: 14.40
}
,
{
   page: 5,
   name: "Age if knownHumidifier", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 354.72,
   left: 311.52,
   width: 39.00,
   height: 14.40
}
,
{
   page: 5,
   name: "CommentsHumidifier", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 354.72,
   left: 352.08,
   width: 222.96,
   height: 14.40
}
,
{
   page: 5,
   name: "YesAir purifier", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 370.08,
   left: 284.52,
   width: 25.56,
   height: 14.52
}
,
{
   page: 5,
   name: "Age if knownAir purifier", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 370.08,
   left: 311.52,
   width: 39.00,
   height: 14.52
}
,
{
   page: 5,
   name: "CommentsAir purifier", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 370.08,
   left: 352.08,
   width: 222.96,
   height: 14.52
}
,
{
   page: 5,
   name: "YesFireplace_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 387.12,
   left: 284.52,
   width: 25.56,
   height: 12.84
}
,
{
   page: 5,
   name: "Age if knownFireplace_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 387.12,
   left: 311.52,
   width: 39.00,
   height: 12.84
}
,
{
   page: 5,
   name: "CommentsFireplace", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 387.12,
   left: 352.08,
   width: 222.96,
   height: 12.84
}
,
{
   page: 5,
   name: "YesFireplace insert", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 400.92,
   left: 284.52,
   width: 25.56,
   height: 14.40
}
,
{
   page: 5,
   name: "Age if knownFireplace insert", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 400.92,
   left: 311.52,
   width: 39.00,
   height: 14.40
}
,
{
   page: 5,
   name: "CommentsFireplace insert", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 400.92,
   left: 352.08,
   width: 222.96,
   height: 14.40
}
,
{
   page: 5,
   name: "YesFireplace starter", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 416.28,
   left: 284.52,
   width: 25.56,
   height: 14.52
}
,
{
   page: 5,
   name: "Age if knownFireplace starter", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 416.28,
   left: 311.52,
   width: 39.00,
   height: 14.52
}
,
{
   page: 5,
   name: "CommentsFireplace starter", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 416.28,
   left: 352.08,
   width: 222.96,
   height: 14.52
}
,
{
   page: 5,
   name: "YesHeating Stove", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 433.32,
   left: 284.52,
   width: 25.56,
   height: 12.84
}
,
{
   page: 5,
   name: "Age if knownHeating Stove", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 433.32,
   left: 311.52,
   width: 39.00,
   height: 12.84
}
,
{
   page: 5,
   name: "CommentsHeating Stove", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 433.32,
   left: 352.08,
   width: 222.96,
   height: 12.84
}
,
{
   page: 5,
   name: "YesFuel tanks_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 447.12,
   left: 284.52,
   width: 25.56,
   height: 14.40
}
,
{
   page: 5,
   name: "Age if knownFuel tanks_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 447.12,
   left: 311.52,
   width: 39.00,
   height: 14.40
}
,
{
   page: 5,
   name: "CommentsFuel tanks", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 447.12,
   left: 352.08,
   width: 222.96,
   height: 14.40
}
,
{
   page: 5,
   name: "Fuel tanks26", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 462.48,
   left: 68.52,
   width: 214.56,
   height: 14.52
}
,
{
   page: 5,
   name: "Yes26", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 462.48,
   left: 284.52,
   width: 25.56,
   height: 14.52
}
,
{
   page: 5,
   name: "Age if known26", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 462.48,
   left: 311.52,
   width: 39.00,
   height: 14.52
}
,
{
   page: 5,
   name: "Comments26", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 462.48,
   left: 352.08,
   width: 222.96,
   height: 14.52
}
,
{
   page: 5,
   name: "YesWater heater", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 529.44,
   left: 284.4,
   width: 25.44,
   height: 13.44
}
,
{
   page: 5,
   name: "Age if knownWater heater", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 529.44,
   left: 311.4,
   width: 39.0,
   height: 13.44
}
,
{
   page: 5,
   name: "CommentsWater heater", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 529.44,
   left: 351.84,
   width: 223.56,
   height: 13.44
}
,
{
   page: 5,
   name: "Yesa Number of Water Heaters", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 545.52,
   left: 284.4,
   width: 25.44,
   height: 13.44
}
,
{
   page: 5,
   name: "Age if knowna Number of Water Heaters", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 545.52,
   left: 311.4,
   width: 39.0,
   height: 13.44
}
,
{
   page: 5,
   name: "Commentsa Number of Water Heaters", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 545.52,
   left: 351.84,
   width: 223.56,
   height: 13.44
}
,
{
   page: 5,
   name: "Yesb Fuel Type", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 561.6,
   left: 284.4,
   width: 25.44,
   height: 13.44
}
,
{
   page: 5,
   name: "Age if knownb Fuel Type", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 561.6,
   left: 311.4,
   width: 39.0,
   height: 13.44
}
,
{
   page: 5,
   name: "Commentsb Fuel Type", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 561.6,
   left: 351.84,
   width: 223.56,
   height: 13.44
}
,
{
   page: 5,
   name: "Yesc Capacity", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 577.56,
   left: 284.4,
   width: 25.44,
   height: 13.56
}
,
{
   page: 5,
   name: "Age if knownc Capacity", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 577.56,
   left: 311.4,
   width: 39.0,
   height: 13.56
}
,
{
   page: 5,
   name: "Commentsc Capacity", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 577.56,
   left: 351.84,
   width: 223.56,
   height: 13.56
}
,
{
   page: 5,
   name: "YesWater filter system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 596.16,
   left: 284.88,
   width: 24.48,
   height: 30.24
}
,
{
   page: 5,
   name: "Age if knownWater filter system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 596.16,
   left: 311.88,
   width: 38.04,
   height: 30.24
}
,
{
   page: 5,
   name: "Owned Leased If leased provide the name and contact information of entity leased from_5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 611.76,
   left: 351.96,
   width: 223.32,
   height: 16.08
}
,
{
   page: 5,
   name: "undefined_35", 
   isText: false,
   type: "checkbox",
   top: 594,
   left: 357.48,
   width: 8.76,
   height: 8.76
}
,
{
   page: 5,
   name: "undefined_36", 
   isText: false,
   type: "checkbox",
   top: 594,
   left: 402.72,
   width: 8.88,
   height: 8.76
}
,
{
   page: 5,
   name: "3_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 649.596,
   left: 353.726,
   width: 221.203,
   height: 13.964
}
,
{
   page: 5,
   name: "YesWater softener", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 632.88,
   left: 284.88,
   width: 24.48,
   height: 30.24
}
,
{
   page: 5,
   name: "Age if knownWater softener", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 632.88,
   left: 311.88,
   width: 38.04,
   height: 30.24
}
,
{
   page: 5,
   name: "contact information of entity leased from", 
   isText: false,
   type: "checkbox",
   top: 630.72,
   left: 357.48,
   width: 8.76,
   height: 8.76
}
,
{
   page: 5,
   name: "Leased If leased provide the name and_2", 
   isText: false,
   type: "checkbox",
   top: 630.72,
   left: 402.72,
   width: 8.88,
   height: 8.76
}
,
{
   page: 5,
   name: "YesIndicate location of master water shutoff in Comments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 667.08,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 5,
   name: "Age if knownIndicate location of master water shutoff in Comments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 667.08,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 5,
   name: "Owned Leased If leased provide the name and contact information of entity leased fromIndicate location of master water shutoff in Comments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 667.08,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 5,
   name: "YesType of well", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 682.56,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 5,
   name: "Age if knownType of well", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 682.56,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 5,
   name: "Owned Leased If leased provide the name and contact information of entity leased fromType of well", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 682.56,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 5,
   name: "Yesa Exempt well outside designated groundwater basin", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 699.24,
   left: 284.88,
   width: 24.48,
   height: 29.64
}
,
{
   page: 5,
   name: "Age if knowna Exempt well outside designated groundwater basin", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 699.24,
   left: 311.88,
   width: 38.04,
   height: 29.64
}
,
{
   page: 5,
   name: "Permit no", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 717.84,
   left: 396.84,
   width: 175.134,
   height: 9.48
}
,
{
   page: 5,
   name: "Check Box10", 
   isText: false,
   type: "checkbox",
   top: 97.396,
   left: 356.595,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box11", 
   isText: false,
   type: "checkbox",
   top: 108.392,
   left: 357.119,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box12", 
   isText: false,
   type: "checkbox",
   top: 119.389,
   left: 357.119,
   width: 10.080,
   height: 10.080
}
,
{
   page: 5,
   name: "Check Box13", 
   isText: false,
   type: "checkbox",
   top: 121.483,
   left: 400.58,
   width: 10.08,
   height: 10.080
}
,
{
   page: 5,
   name: "Text14", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 94.254,
   left: 429.904,
   width: 27.469,
   height: 12.051
}
,
{
   page: 5,
   name: "Check Box15", 
   isText: false,
   type: "checkbox",
   top: 698.5284,
   left: 358.166,
   width: 10.080,
   height: 10.0801
}
,
{
   page: 5,
   name: "Text39", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 48.033,
   left: 311.52,
   width: 39.00,
   height: 14.400
}
,
{
   page: 5,
   name: "Text40", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 62.836,
   left: 311.52,
   width: 39.00,
   height: 14.400
}
,
{
   page: 5,
   name: "Text41", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 77.451,
   left: 311.52,
   width: 39.00,
   height: 14.400
}
,
{
   page: 5,
   name: "Text42", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 133.243,
   left: 311.52,
   width: 39.00,
   height: 14.400
}
,
{
   page: 5,
   name: "Text43", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 148.141,
   left: 311.52,
   width: 39.00,
   height: 14.400
}
,
{
   page: 5,
   name: "Text44", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 163.519,
   left: 311.52,
   width: 39.00,
   height: 14.400
}
,
{
   page: 6,
   name: "Permit no_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 136.08,
   left: 396.84,
   width: 107.88,
   height: 9.48
}
,
{
   page: 6,
   name: "Permit no_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 79.8,
   left: 396.84,
   width: 107.88,
   height: 9.48
}
,
{
   page: 6,
   name: "Permit no_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 100.56,
   left: 396.84,
   width: 107.88,
   height: 9.48
}
,
{
   page: 6,
   name: "b Small capacity well inside designated groundwater basin", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 151.44,
   left: 284.76,
   width: 24.72,
   height: 77.88
}
,
{
   page: 6,
   name: "Permit no_5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 216.84,
   left: 396.84,
   width: 112.44,
   height: 9.48
}
,
{
   page: 6,
   name: "Permit no_6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 181.32,
   left: 394.56,
   width: 112.44,
   height: 9.48
}
,
{
   page: 6,
   name: "c Nonexempt well outside designated groundwater basin irrigation or other uses", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 232.2,
   left: 284.76,
   width: 24.72,
   height: 84.96
}
,
{
   page: 6,
   name: "Augmented well irrigationlivestockother", 
   isText: false,
   type: "checkbox",
   top: 232.2,
   left: 357.48,
   width: 8.76,
   height: 8.76
}
,
{
   page: 6,
   name: "Nonaugmented well irrigationlivestock", 
   isText: false,
   type: "checkbox",
   top: 273.6,
   left: 357.48,
   width: 8.76,
   height: 8.76
}
,
{
   page: 6,
   name: "Well use", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 241.44,
   left: 409.389,
   width: 164.793,
   height: 10.004
}
,
{
   page: 6,
   name: "Permit no_7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 251.88,
   left: 409.389,
   width: 164.793,
   height: 9.48
}
,
{
   page: 6,
   name: "Name of augmentation plan", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 262.2,
   left: 478.771,
   width: 95.411,
   height: 10.135
}
,
{
   page: 6,
   name: "Well use_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 282.84,
   left: 409.389,
   width: 164.793,
   height: 9.48
}
,
{
   page: 6,
   name: "Permit no_8", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 293.16,
   left: 409.389,
   width: 164.793,
   height: 9.48
}
,
{
   page: 6,
   name: "d Nonexempt well inside designated groundwater basin", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 320.04,
   left: 284.76,
   width: 24.72,
   height: 240.12
}
,
{
   page: 6,
   name: "Nontributarynot subject to replacement plan", 
   isText: false,
   type: "checkbox",
   top: 320.04,
   left: 375.48,
   width: 8.76,
   height: 8.76
}
,
{
   page: 6,
   name: "Notnontributarysubject to existing replacement", 
   isText: false,
   type: "checkbox",
   top: 361.44,
   left: 375.48,
   width: 8.76,
   height: 8.76
}
,
{
   page: 6,
   name: "Well use_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 329.28,
   left: 429.24,
   width: 121.44,
   height: 9.48
}
,
{
   page: 6,
   name: "Permit no_9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 339.72,
   left: 432.84,
   width: 116.88,
   height: 9.48
}
,
{
   page: 6,
   name: "Determination case no", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 350.04,
   left: 478.44,
   width: 72.00,
   height: 9.48
}
,
{
   page: 6,
   name: "Well use_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 381,
   left: 429.24,
   width: 121.44,
   height: 9.48
}
,
{
   page: 6,
   name: "Permit no_10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 391.44,
   left: 432.84,
   width: 116.88,
   height: 9.48
}
,
{
   page: 6,
   name: "Determination case no_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 401.76,
   left: 478.44,
   width: 72.00,
   height: 9.48
}
,
{
   page: 6,
   name: "Notnontributaryrequires replacement plan with", 
   isText: false,
   type: "checkbox",
   top: 413.16,
   left: 375.48,
   width: 8.76,
   height: 8.76
}
,
{
   page: 6,
   name: "Well use_5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 432.72,
   left: 429.24,
   width: 121.44,
   height: 9.48
}
,
{
   page: 6,
   name: "Permit no_11", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 443.16,
   left: 432.84,
   width: 116.88,
   height: 9.48
}
,
{
   page: 6,
   name: "Determination case no_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 453.48,
   left: 478.44,
   width: 72.00,
   height: 9.48
}
,
{
   page: 6,
   name: "Large capacity", 
   isText: false,
   type: "checkbox",
   top: 464.88,
   left: 375.48,
   width: 8.76,
   height: 8.88
}
,
{
   page: 6,
   name: "Well use_6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 474.24,
   left: 429.24,
   width: 121.44,
   height: 9.48
}
,
{
   page: 6,
   name: "Permit no_12", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 484.56,
   left: 432.84,
   width: 116.88,
   height: 9.48
}
,
{
   page: 6,
   name: "Determination case no_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 494.88,
   left: 478.44,
   width: 72.00,
   height: 9.48
}
,
{
   page: 6,
   name: "Well metered", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 562.8,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 6,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes NoWell metered", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 562.8,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 6,
   name: "Well Pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 578.16,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 6,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes NoWell Pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 578.16,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 6,
   name: "7Row1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 561.578,
   left: 311.475,
   width: 37.604,
   height: 13.364
}
,
{
   page: 6,
   name: "a Brand name and pump number", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 593.52,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 6,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes Noa Brand name and pump number", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 593.52,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 6,
   name: "7Row2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 577.058,
   left: 311.475,
   width: 37.604,
   height: 13.364
}
,
{
   page: 6,
   name: "b Date installed", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 609,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 6,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes Nob Date installed", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 609,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 6,
   name: "7Row3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 592.418,
   left: 311.475,
   width: 37.604,
   height: 13.364
}
,
{
   page: 6,
   name: "c Date of last inspection", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 624.36,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 6,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes Noc Date of last inspection", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 624.36,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 6,
   name: "7Row4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 607.778,
   left: 311.475,
   width: 37.604,
   height: 13.364
}
,
{
   page: 6,
   name: "d Date of last service", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 639.72,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 6,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes Nod Date of last service", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 639.72,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 6,
   name: "7Row5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 623.258,
   left: 311.475,
   width: 37.604,
   height: 13.364
}
,
{
   page: 6,
   name: "e Depth", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 655.2,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 6,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes Noe Depth", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 655.2,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 6,
   name: "7Row6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 638.618,
   left: 311.475,
   width: 37.604,
   height: 13.364
}
,
{
   page: 6,
   name: "f GPM and date last measured", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 670.56,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 6,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes Nof GPM and date last measured", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 670.56,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 6,
   name: "Galvanized pipe", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 685.92,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 6,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes NoGalvanized pipe", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 685.92,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 6,
   name: "Polybutylene pipe", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 701.4,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 6,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes NoPolybutylene pipe", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 701.4,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 6,
   name: "Cistern water storage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 716.76,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 6,
   name: "Nontributarynot subject to replacement plan Well use Permit no Determination case no Notnontributarysubject to existing replacement plan Well use Permit no Determination case no Notnontributaryrequires replacement plan with no existing replacement plan Well use Permit no Determination case no Large capacity Well use Permit no Determination case no Replacement plan required yes no If yes is a replacement plan in place Yes NoCistern water storage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 716.76,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 6,
   name: "Check Box16", 
   isText: false,
   type: "checkbox",
   top: 50.269,
   left: 357.119,
   width: 10.080,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box17", 
   isText: false,
   type: "checkbox",
   top: 90.589,
   left: 356.071,
   width: 10.080,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box18", 
   isText: false,
   type: "checkbox",
   top: 113.629,
   left: 356.071,
   width: 10.080,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box19", 
   isText: false,
   type: "checkbox",
   top: 150.807,
   left: 356.595,
   width: 10.080,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box20", 
   isText: false,
   type: "checkbox",
   top: 194.268,
   left: 356.595,
   width: 10.080,
   height: 10.080
}
,
{
   page: 6,
   name: "Text21", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 51.316,
   left: 285.381,
   width: 24.328,
   height: 94.785
}
,
{
   page: 6,
   name: "Text22", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 50.793,
   left: 311.039,
   width: 39.513,
   height: 96.879
}
,
{
   page: 6,
   name: "Text23", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 150.283,
   left: 311.563,
   width: 38.989,
   height: 78.029
}
,
{
   page: 6,
   name: "Text24", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 233.017,
   left: 311.039,
   width: 38.466,
   height: 81.695
}
,
{
   page: 6,
   name: "Text25", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 328.842,
   left: 311.563,
   width: 37.942,
   height: 162.335
}
,
{
   page: 6,
   name: "Text26", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 203.694,
   left: 358.166,
   width: 218.072,
   height: 11.004
}
,
{
   page: 6,
   name: "Text27", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 124.101,
   left: 355.548,
   width: 217.025,
   height: 8.909
}
,
{
   page: 6,
   name: "Text28", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 653.496,
   left: 311.475,
   width: 37.604,
   height: 13.363
}
,
{
   page: 6,
   name: "Text29", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 669.205,
   left: 311.475,
   width: 37.604,
   height: 13.364
}
,
{
   page: 6,
   name: "Text30", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 684.914,
   left: 311.475,
   width: 37.604,
   height: 13.3636
}
,
{
   page: 6,
   name: "Text31", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 699.0521,
   left: 311.475,
   width: 37.604,
   height: 13.3636
}
,
{
   page: 6,
   name: "Text32", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 715.8083,
   left: 311.475,
   width: 37.604,
   height: 13.3637
}
,
{
   page: 6,
   name: "Check Box21", 
   isText: false,
   type: "checkbox",
   top: 505.966,
   left: 513.82,
   width: 10.08,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box22", 
   isText: false,
   type: "checkbox",
   top: 505.966,
   left: 540.657,
   width: 10.080,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box23", 
   isText: false,
   type: "checkbox",
   top: 526.911,
   left: 428.075,
   width: 10.080,
   height: 10.080
}
,
{
   page: 6,
   name: "Check Box24", 
   isText: false,
   type: "checkbox",
   top: 536.73,
   left: 428.729,
   width: 10.080,
   height: 10.08
}
,
{
   page: 7,
   name: "a Number of gallons", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 49.56,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Supplemental water purchased in past 2 years If yes identify where supplemental water was purchased from in Comments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 67.28,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "11Row1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 46.637,
   left: 353.486,
   width: 221.159,
   height: 16.320
}
,
{
   page: 7,
   name: "undefined_37", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 47.04,
   left: 314.379,
   width: 34.920,
   height: 14.52
}
,
{
   page: 7,
   name: "12", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 123.6,
   left: 68.28,
   width: 214.56,
   height: 12.84
}
,
{
   page: 7,
   name: "12Row1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 65.957,
   left: 353.846,
   width: 220.439,
   height: 30.120
}
,
{
   page: 7,
   name: "YesWater heaters", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 175.44,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if KnownWater heaters", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 175.44,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "CommentsWater heaters", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 175.44,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "YesWater filter system_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 190.8,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if KnownWater filter system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 190.8,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "CommentsWater filter system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 190.8,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "YesWater softener_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 206.28,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if KnownWater softener", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 206.28,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "CommentsWater softener", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 206.28,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "YesWater system pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 221.64,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if KnownWater system pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 221.64,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "CommentsWater system pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 221.64,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "YesSauna", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 237,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if KnownSauna", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 237,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "CommentsSauna", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 237,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "YesHot tub or spa", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 252.48,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if KnownHot tub or spa", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 252.48,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "CommentsHot tub or spa", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 252.48,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "YesSteam roomshower", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 267.84,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if KnownSteam roomshower", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 267.84,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "CommentsSteam roomshower", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 267.84,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "YesUnderground sprinkler system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 283.2,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if KnownUnderground sprinkler system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 283.2,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "CommentsUnderground sprinkler system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 283.2,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "YesFire sprinkler system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 298.68,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if KnownFire sprinkler system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 298.68,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "CommentsFire sprinkler system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 298.68,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "YesBackflow prevention device", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 314.04,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if KnownBackflow prevention device", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 314.04,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "CommentsBackflow prevention device", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 314.04,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "YesIrrigation pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 329.4,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if KnownIrrigation pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 329.4,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "CommentsIrrigation pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 329.4,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "Irrigation pump24", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 344.88,
   left: 68.28,
   width: 214.56,
   height: 12.84
}
,
{
   page: 7,
   name: "Yes24", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 344.88,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if Known24", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 344.88,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "Comments24", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 344.88,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "24Row1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 102.448,
   left: 353.203,
   width: 221.726,
   height: 16.582
}
,
{
   page: 7,
   name: "25", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 63.885,
   left: 312.658,
   width: 37.167,
   height: 34.811
}
,
{
   page: 7,
   name: "YesLeaks backups or similar problems with any portion of the water or plumbing systems including lines and water pressure or damage therefrom", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 399.96,
   left: 284.76,
   width: 24.72,
   height: 36.48
}
,
{
   page: 7,
   name: "Age if knownLeaks backups or similar problems with any portion of the water or plumbing systems including lines and water pressure or damage therefrom", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 400.32,
   left: 312.12,
   width: 37.56,
   height: 36.12
}
,
{
   page: 7,
   name: "CommentsLeaks backups or similar problems with any portion of the water or plumbing systems including lines and water pressure or damage therefrom", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 400.32,
   left: 352.56,
   width: 222.12,
   height: 36.12
}
,
{
   page: 7,
   name: "YesWell", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 439.08,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if knownWell", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 439.08,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "CommentsWell", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 439.08,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "YesPool", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 454.44,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if knownPool", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 454.44,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "CommentsPool", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 454.44,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "YesIrrigation system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 469.8,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if knownIrrigation system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 469.8,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "CommentsIrrigation system", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 469.8,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "29", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 103.245,
   left: 311.312,
   width: 37.407,
   height: 16.156
}
,
{
   page: 7,
   name: "Water has been tested for potability", 
   isText: false,
   type: "checkbox",
   top: 486.72,
   left: 206.88,
   width: 8.88,
   height: 8.88
}
,
{
   page: 7,
   name: "Yes_3", 
   isText: false,
   type: "checkbox",
   top: 486.72,
   left: 235.68,
   width: 8.88,
   height: 8.88
}
,
{
   page: 7,
   name: "YesWater has been tested for potability Yes No a Indicate result of test and provide the most recent records and reports pertaining to such testing", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 485.64,
   left: 284.76,
   width: 24.72,
   height: 48.48
}
,
{
   page: 7,
   name: "Age if knownWater has been tested for potability Yes No a Indicate result of test and provide the most recent records and reports pertaining to such testing", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 486,
   left: 312.12,
   width: 37.56,
   height: 48.12
}
,
{
   page: 7,
   name: "CommentsWater has been tested for potability Yes No a Indicate result of test and provide the most recent records and reports pertaining to such testing", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 486,
   left: 352.56,
   width: 222.12,
   height: 48.12
}
,
{
   page: 7,
   name: "Water has been tested for potability Yes No a Indicate result of test and provide the most recent records and reports pertaining to such testing30", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 536.64,
   left: 68.28,
   width: 214.56,
   height: 12.84
}
,
{
   page: 7,
   name: "Yes30", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 536.64,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Age if known30", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 536.64,
   left: 311.4,
   width: 39.0,
   height: 12.84
}
,
{
   page: 7,
   name: "Comments30", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 536.64,
   left: 351.84,
   width: 223.56,
   height: 12.84
}
,
{
   page: 7,
   name: "YesRow1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 625.56,
   left: 294,
   width: 28.8,
   height: 49.80
}
,
{
   page: 7,
   name: "CommentsRow1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 625.68,
   left: 325.56,
   width: 249.12,
   height: 49.68
}
,
{
   page: 7,
   name: "2_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 676.32,
   left: 77.4,
   width: 214.44,
   height: 14.52
}
,
{
   page: 7,
   name: "Yes2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 676.32,
   left: 293.4,
   width: 30.0,
   height: 14.52
}
,
{
   page: 7,
   name: "Comments2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 676.32,
   left: 324.84,
   width: 250.56,
   height: 14.52
}
,
{
   page: 7,
   name: "Text15", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 102.11,
   left: 284.4,
   width: 25.44,
   height: 12.84
}
,
{
   page: 7,
   name: "Text19", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 123.055,
   left: 353.203,
   width: 221.726,
   height: 12.000
}
,
{
   page: 7,
   name: "Text20", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 123.055,
   left: 311.312,
   width: 37.407,
   height: 12.229
}
,
{
   page: 7,
   name: "Text45", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 122.401,
   left: 284.4,
   width: 25.44,
   height: 12.840
}
,
{
   page: 8,
   name: "Public sanitary sewer service", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 49.56,
   left: 293.4,
   width: 30.0,
   height: 12.84
}
,
{
   page: 8,
   name: "1Row1_3", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 63.709,
   left: 324.926,
   width: 248.530,
   height: 23.847
}
,
{
   page: 8,
   name: "a Name and contact information of public sewer service provider", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 65.28,
   left: 293.76,
   width: 29.28,
   height: 24.48
}
,
{
   page: 8,
   name: "1Row2_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 90.829,
   left: 324.926,
   width: 248.530,
   height: 12.720
}
,
{
   page: 8,
   name: "b Date the sewer line was last scoped", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 92.4,
   left: 293.4,
   width: 30.0,
   height: 12.72
}
,
{
   page: 8,
   name: "Community sanitary sewer service", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 107.76,
   left: 293.4,
   width: 30.0,
   height: 12.84
}
,
{
   page: 8,
   name: "2Row1_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 121.909,
   left: 324.926,
   width: 248.530,
   height: 23.847
}
,
{
   page: 8,
   name: "a Name and contact information of community sewer service provider", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 123.48,
   left: 293.76,
   width: 29.28,
   height: 24.48
}
,
{
   page: 8,
   name: "2Row2_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 149.029,
   left: 324.926,
   width: 248.530,
   height: 12.720
}
,
{
   page: 8,
   name: "b Date the sewer line was last scoped_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 150.6,
   left: 293.4,
   width: 30.0,
   height: 12.72
}
,
{
   page: 8,
   name: "Septic System", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 166.32,
   left: 293.76,
   width: 29.28,
   height: 24.48
}
,
{
   page: 8,
   name: "a Type_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 193.32,
   left: 293.4,
   width: 30.0,
   height: 12.84
}
,
{
   page: 8,
   name: "Tank", 
   isText: false,
   type: "checkbox",
   top: 194.88,
   left: 330.48,
   width: 8.76,
   height: 8.76
}
,
{
   page: 8,
   name: "Leach", 
   isText: false,
   type: "checkbox",
   top: 194.88,
   left: 366,
   width: 8.88,
   height: 8.76
}
,
{
   page: 8,
   name: "Lagoon", 
   isText: false,
   type: "checkbox",
   top: 194.88,
   left: 405.12,
   width: 8.76,
   height: 8.76
}
,
{
   page: 8,
   name: "b Date of issuance of the latest Individual Use Permit", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 209.16,
   left: 293.76,
   width: 29.28,
   height: 24.36
}
,
{
   page: 8,
   name: "Tank Leach Lagoonb Date of issuance of the latest Individual Use Permit", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 209.16,
   left: 325.2,
   width: 249.6,
   height: 24.36
}
,
{
   page: 8,
   name: "3Row3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 333.032,
   left: 293.148,
   width: 29.847,
   height: 12.840
}
,
{
   page: 8,
   name: "c Date of the latest inspection", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 236.16,
   left: 293.4,
   width: 30.0,
   height: 12.84
}
,
{
   page: 8,
   name: "Tank Leach Lagoonc Date of the latest inspection", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 236.16,
   left: 324.84,
   width: 250.32,
   height: 12.84
}
,
{
   page: 8,
   name: "3Row4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 332.636,
   left: 325.09,
   width: 248.726,
   height: 12.316
}
,
{
   page: 8,
   name: "d Date of the latest pumping", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 251.52,
   left: 293.4,
   width: 30.0,
   height: 12.84
}
,
{
   page: 8,
   name: "Tank Leach Lagoond Date of the latest pumping", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 251.52,
   left: 324.84,
   width: 250.32,
   height: 12.84
}
,
{
   page: 8,
   name: "Maintenance agreement is mandated Name and contact", 
   isText: false,
   type: "checkbox",
   top: 278.64,
   left: 329.76,
   width: 8.76,
   height: 8.76
}
,
{
   page: 8,
   name: "e System is under a maintenance agreement pumpedinspected on a regular basis", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 267.6,
   left: 294,
   width: 28.8,
   height: 48.12
}
,
{
   page: 8,
   name: "Maintenance agreement is not Mandated", 
   isText: false,
   type: "checkbox",
   top: 314.64,
   left: 329.76,
   width: 8.76,
   height: 8.76
}
,
{
   page: 8,
   name: "Other sanitary sewer service", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 318.36,
   left: 293.4,
   width: 30.0,
   height: 12.84
}
,
{
   page: 8,
   name: "Maintenance agreement is mandated Name and contact information of entity that mandates the maintenance agreement Maintenance agreement is not MandatedOther sanitary sewer service", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 318.36,
   left: 324.84,
   width: 250.32,
   height: 12.84
}
,
{
   page: 8,
   name: "Gray water storageuse6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 349.2,
   left: 77.28,
   width: 214.56,
   height: 12.72
}
,
{
   page: 8,
   name: "6Row1_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 346.942,
   left: 325.046,
   width: 249.861,
   height: 12.840
}
,
{
   page: 8,
   name: "YesLeaks backups or other similar problems with any portion of the sewage systems including sewer lines or damage therefrom", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 401.52,
   left: 294,
   width: 28.8,
   height: 36.24
}
,
{
   page: 8,
   name: "CommentsLeaks backups or other similar problems with any portion of the sewage systems including sewer lines or damage therefrom", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 401.64,
   left: 325.44,
   width: 250.44,
   height: 36.12
}
,
{
   page: 8,
   name: "YesLift station sewage ejector pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 440.4,
   left: 293.4,
   width: 30.0,
   height: 12.72
}
,
{
   page: 8,
   name: "CommentsLift station sewage ejector pump", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 440.4,
   left: 324.72,
   width: 251.88,
   height: 12.72
}
,
{
   page: 8,
   name: "Lift station sewage ejector pump9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 455.76,
   left: 77.28,
   width: 214.56,
   height: 12.84
}
,
{
   page: 8,
   name: "Yes9_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 455.76,
   left: 293.4,
   width: 30.0,
   height: 12.84
}
,
{
   page: 8,
   name: "Comments9_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 455.76,
   left: 324.72,
   width: 251.88,
   height: 12.84
}
,
{
   page: 8,
   name: "YesIncluded fixtures and equipment", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 521.64,
   left: 293.4,
   width: 30.0,
   height: 12.84
}
,
{
   page: 8,
   name: "CommentsIncluded fixtures and equipment", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 521.64,
   left: 324.84,
   width: 251.52,
   height: 12.84
}
,
{
   page: 8,
   name: "YesStains on carpet", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 535.44,
   left: 293.4,
   width: 30.0,
   height: 14.52
}
,
{
   page: 8,
   name: "CommentsStains on carpet", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 535.44,
   left: 324.84,
   width: 251.52,
   height: 14.52
}
,
{
   page: 8,
   name: "YesFloors", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 552.48,
   left: 293.4,
   width: 30.0,
   height: 12.84
}
,
{
   page: 8,
   name: "CommentsFloors", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 552.48,
   left: 324.84,
   width: 251.52,
   height: 12.84
}
,
{
   page: 8,
   name: "Floors4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 567.84,
   left: 77.4,
   width: 214.44,
   height: 12.84
}
,
{
   page: 8,
   name: "Yes4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 567.84,
   left: 293.4,
   width: 30.0,
   height: 12.84
}
,
{
   page: 8,
   name: "Comments4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 567.84,
   left: 324.84,
   width: 251.52,
   height: 12.84
}
,
{
   page: 8,
   name: "YesBuilding code city or county violations", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 668.64,
   left: 297.12,
   width: 26.04,
   height: 12.84
}
,
{
   page: 8,
   name: "CommentsBuilding code city or county violations", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 668.64,
   left: 324.72,
   width: 250.68,
   height: 12.84
}
,
{
   page: 8,
   name: "YesAny building or improvements constructed within the past one year before this Date without approval by the owners association or its designated approving body", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 686.28,
   left: 297.6,
   width: 25.08,
   height: 30.12
}
,
{
   page: 8,
   name: "CommentsAny building or improvements constructed within the past one year before this Date without approval by the owners association or its designated approving body", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 686.28,
   left: 325.2,
   width: 249.72,
   height: 30.12
}
,
{
   page: 8,
   name: "YesAny additions or alterations made with a Building Permit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 718.8,
   left: 297.12,
   width: 26.04,
   height: 14.52
}
,
{
   page: 8,
   name: "CommentsAny additions or alterations made with a Building Permit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 718.8,
   left: 324.72,
   width: 250.68,
   height: 14.52
}
,
{
   page: 8,
   name: "Text16", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 47.927,
   left: 325.581,
   width: 248.530,
   height: 12.720
}
,
{
   page: 8,
   name: "Text17", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 105.728,
   left: 324.926,
   width: 248.530,
   height: 12.720
}
,
{
   page: 8,
   name: "Text18", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 347.565,
   left: 293.148,
   width: 29.847,
   height: 12.840
}
,
{
   page: 9,
   name: "4_2", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 49.015,
   left: 325.603,
   width: 248.115,
   height: 22.298
}
,
{
   page: 9,
   name: "Any additions or nonaesthetic alterations made without a Building Permit", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 49.92,
   left: 297.48,
   width: 25.32,
   height: 22.44
}
,
{
   page: 9,
   name: "Notice of ADA complaint or report", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 73.32,
   left: 297.12,
   width: 26.04,
   height: 14.40
}
,
{
   page: 9,
   name: "Notice of ADA complaint or report6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 88.68,
   left: 68.28,
   width: 227.40,
   height: 14.52
}
,
{
   page: 9,
   name: "L", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 73.702,
   left: 324.915,
   width: 250.014,
   height: 12.556
}
,
{
   page: 9,
   name: "1_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 89.237,
   left: 298.854,
   width: 23.040,
   height: 12.818
}
,
{
   page: 9,
   name: "YesRadon tests conducted on the Property Provide copies of the most recent records and reports pertaining to radon concentrations within the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 155.64,
   left: 298.2,
   width: 24.84,
   height: 36.48
}
,
{
   page: 9,
   name: "CommentsRadon tests conducted on the Property Provide copies of the most recent records and reports pertaining to radon concentrations within the Property", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 156,
   left: 325.56,
   width: 249.12,
   height: 36.12
}
,
{
   page: 9,
   name: "2_6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 88.415,
   left: 324.555,
   width: 250.211,
   height: 12.993
}
,
{
   page: 9,
   name: "YesRadon concentrations detected or mitigation or remediation performed Provide a full description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 195,
   left: 298.2,
   width: 24.84,
   height: 22.56
}
,
{
   page: 9,
   name: "CommentsRadon concentrations detected or mitigation or remediation performed Provide a full description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 195,
   left: 325.2,
   width: 249.84,
   height: 22.56
}
,
{
   page: 9,
   name: "YesRadon mitigation system installed on Property Provide all information known by Seller about the radon mitigation system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 222.36,
   left: 298.32,
   width: 24.60,
   height: 30.12
}
,
{
   page: 9,
   name: "CommentsRadon mitigation system installed on Property Provide all information known by Seller about the radon mitigation system", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 222.36,
   left: 325.32,
   width: 249.60,
   height: 30.12
}
,
{
   page: 9,
   name: "Radon mitigation system installed on Property Provide all information known by Seller about the radon mitigation system4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 256.44,
   left: 68.4,
   width: 228.0,
   height: 12.84
}
,
{
   page: 9,
   name: "Yes4_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 256.44,
   left: 297.84,
   width: 25.56,
   height: 12.84
}
,
{
   page: 9,
   name: "Comments4_2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 256.44,
   left: 324.84,
   width: 250.56,
   height: 12.84
}
,
{
   page: 9,
   name: "YesWritten reports of any building site roofing soils water sewer mold or engineering investigations or studies of the Property Provide copies of all such reports in possession of Seller", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 321.12,
   left: 298.2,
   width: 24.84,
   height: 44.52
}
,
{
   page: 9,
   name: "CommentsWritten reports of any building site roofing soils water sewer mold or engineering investigations or studies of the Property Provide copies of all such reports in possession of Seller", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 321.48,
   left: 325.56,
   width: 249.12,
   height: 44.16
}
,
{
   page: 9,
   name: "2_7", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 403.058,
   left: 298.221,
   width: 24.840,
   height: 22.506
}
,
{
   page: 9,
   name: "YesStructural architectural and engineering plans andor specifications for any existing improvements Provide copies of all such reports in possession of Seller", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 370.44,
   left: 298.32,
   width: 24.60,
   height: 30.12
}
,
{
   page: 9,
   name: "CommentsStructural architectural and engineering plans andor specifications for any existing improvements Provide copies of all such reports in possession of Seller", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 370.44,
   left: 325.32,
   width: 249.60,
   height: 30.12
}
,
{
   page: 9,
   name: "3_4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 427.538,
   left: 297.861,
   width: 24.513,
   height: 14.040
}
,
{
   page: 9,
   name: "CommentsRow3", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 405,
   left: 325.2,
   width: 249.84,
   height: 22.44
}
,
{
   page: 9,
   name: "CommentsRow4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 429.96,
   left: 324.84,
   width: 250.56,
   height: 12.84
}
,
{
   page: 9,
   name: "CommentsRow5", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 444.12,
   left: 325.2,
   width: 249.84,
   height: 24.12
}
,
{
   page: 9,
   name: "Any litigation alleging negligent construction or defective building products", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 471.12,
   left: 298.08,
   width: 24.96,
   height: 22.44
}
,
{
   page: 9,
   name: "CommentsAny litigation alleging negligent construction or defective building products", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 471.12,
   left: 325.2,
   width: 249.84,
   height: 22.44
}
,
{
   page: 9,
   name: "7_5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 555.873,
   left: 297.337,
   width: 25.560,
   height: 13.920
}
,
{
   page: 9,
   name: "Any award or payment of money in lieu of repairs for defective building products or poor construction", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 496.56,
   left: 298.08,
   width: 24.96,
   height: 22.44
}
,
{
   page: 9,
   name: "CommentsAny award or payment of money in lieu of repairs for defective building products or poor construction", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 496.56,
   left: 325.2,
   width: 249.84,
   height: 22.44
}
,
{
   page: 9,
   name: "8_3", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 443.837,
   left: 297.697,
   width: 24.840,
   height: 23.029
}
,
{
   page: 9,
   name: "Any release signed regarding defective products or poor construction that would limit a future owner from making a claim", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 526.56,
   left: 298.2,
   width: 24.72,
   height: 28.80
}
,
{
   page: 9,
   name: "CommentsAny release signed regarding defective products or poor construction that would limit a future owner from making a claim", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 523.92,
   left: 325.32,
   width: 249.60,
   height: 30.12
}
,
{
   page: 9,
   name: "Any release signed regarding defective products or poor construction that would limit a future owner from making a claim9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 558,
   left: 68.4,
   width: 228.0,
   height: 12.84
}
,
{
   page: 9,
   name: "Comments9_3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 558,
   left: 324.84,
   width: 250.56,
   height: 12.84
}
,
{
   page: 9,
   name: "the Additional Structure attach additional pages as necessary 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 628.68,
   left: 36,
   width: 534.96,
   height: 10.56
}
,
{
   page: 9,
   name: "the Additional Structure attach additional pages as necessary 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 639.96,
   left: 36,
   width: 534.96,
   height: 10.80
}
,
{
   page: 9,
   name: "the Additional Structure attach additional pages as necessary 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 651.48,
   left: 36,
   width: 534.96,
   height: 10.80
}
,
{
   page: 9,
   name: "the Additional Structure attach additional pages as necessary 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 663,
   left: 36,
   width: 534.96,
   height: 10.8
}
,
{
   page: 9,
   name: "the Additional Structure attach additional pages as necessary 5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 674.52,
   left: 36,
   width: 534.96,
   height: 10.80
}
,
{
   page: 9,
   name: "the Additional Structure attach additional pages as necessary 6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 686.04,
   left: 36,
   width: 534.96,
   height: 10.80
}
] }
